//  $(document).ready(function(){
//    alert("hey...");
//     $("body").on("click",".main-product-thumbnail-image-wrapper-inner",function(){

//     var new_html= $(this).parents(".main-product-thumbnail-image-wrapper").last().html();

//     $(".product-single__media-wrapper.image-2 .main-product-thumbnail-image-wrapper").html(new_html);
//     $(".product-single__media-wrapper.image-2 .main-product-thumbnail-image-wrapper").find("a").css("display","block");
//     $(".product-single__media-wrapper.image-2 .main-product-thumbnail-image-wrapper .main-product-thumbnail-image-wrapper-inner").css("display","none");
// });

//   });

$(document).ready(function () {
  /* 09-sep-2024 script  window width and height calculate script */
  setTimeout(function () {
    $(
      ".grid .grid__item .product-main-images-slider.custom-main-image-wrapper .product-single__media-wrapper"
    )
      .eq(0)
      .removeClass("hide");
  }, 1000);
  function OnLoads() {
    if (window.matchMedia("(min-width: 1023px)").matches) {
      var mainWidth = $("aside#main-collection-filters").width();
      $(
        ".accordion_first_container .page-width > div, .accordion_center_container h3, .accordion_second_container .page-width > div"
      ).css("margin-left", mainWidth);
      var mainCollHeight = $(
        ".collection-page-width .product-grid-container .collection"
      ).height();
      $("aside#main-collection-filters").css("height", mainCollHeight);
    }
  }
  OnLoads();
  $(window).on("resize", function () {
    OnLoads();
  });
  /* 09-sep-2024 script  window width and height calculate script */

  /* 09-sep-2024  Accordion on click script  */
  $(".accordion_main_heading_container").on("click", function () {
    $(this).find(".accordion_icon").toggle();
    $(this).parent().find(".accordionDescriptionContainer").slideToggle();
    var windowWidth = $(window).width();

    if (windowWidth > 1025) {
      if ($(this).parent().parent().hasClass("toggled-cstm")) {
        $(this).parent().parent().removeClass("toggled-cstm");
      } else {
        $(this).parent().parent().addClass("toggled-cstm");
      }
    }
  });
  /* 09-sep-2024  Accordion on click script  */

  function lineItem() {
    //console.log("archive-sale-final")
    const $items = $("p.upcart-item-property");

    $items.each(function () {
      const $this = $(this);
      const $span = $this.find("span");
      const text = $span.text();

      if (text === "Archive Item - Final Sale") {
        $this.closest(".cart-item").addClass("has-archive");
      }
    });

    $items.each(function () {
      const $this = $(this);
      const $span = $this.find("span");
      const text = $span.text();
      //console.log("text", text);
      if (text === "Archive Item - Final Sale") {
        $this.find("strong").hide();
        $span.addClass("archive-sale-final");
        $this
          .closest(".UpcartDesignSettings__cartTextSubduedColor")
          .css({ opacity: "1" });
      } else if (text === "Custom Item - Final Sale") {
        if ($this.closest(".cart-item").hasClass("has-archive")) {
          $this.hide();
        } else {
          $this.find("strong").hide();
          $span.addClass("custom-sale-final");
          $this
            .closest(".UpcartDesignSettings__cartTextSubduedColor")
            .css({ opacity: "1" });
        }
      }
    });
  }

  lineItem();
  $(".product-form__cart-submit").click(function () {
    lineItem();
  });

  $(document).on("click", ".cstm-atc-bttn", function () {
    let itemFound = false;

    $(".upcart-product-title-link").each(function () {
      let existCartItem = $(this).text();
      if (existCartItem === "Full Set of Sample Boards") {
        itemFound = true;
      }
    });
    if (itemFound == true) {
      $(".custom-model-main").hide();
      let spanButton = $(this)
        .parent()
        .find("span.btn.product-form__cart-submit");
      spanButton.removeClass("cstm-atc-bttn");
      spanButton.addClass("exist_product");
      if (spanButton.hasClass("exist_product")) {
        $("button.btn.product-form__cart-submit").trigger("click");
      }
    } else {
      $(".custom-model-main").show();
    }
  });

  $(document).on("click", ".exist_product", function () {
    let itemFound = false;
    $(".upcart-product-title-link").each(function () {
      let existCartItem = $(this).text();
      if (existCartItem === "Full Set of Sample Boards") {
        itemFound = true;
      }
    });

    if (itemFound == true) {
      $("button.btn.product-form__cart-submit").trigger("click");
    } else {
      $(".custom-model-main").show();
    }
  });

  $(document).on("click", ".close-btn", function () {
    $("button.btn.product-form__cart-submit").trigger("click");
  });

  $(document).on("click", ".close-btn", function () {
    $(".custom-model-main").hide();
  });

  // lineItem();

  $(document).on("click", "button.btn.product-form__cart-submit", function () {
    $("p.upcart-item-property").each(function () {
      if ($(this).find("span").text() == "Final Sale") {
        $(this).find("strong").hide();
        $("#UpcartPopup p strong").hide();
      }
    });
  });

  setInterval(lineItem, 20);

  $(document).ready(function () {
    // Initially check if there's a checked input and show its value
    const selectedGemstone = $(".swatch-element-data input:checked")
      .closest(".swatch-element-data")
      .attr("data-value");
    // <span class="selected-swatch-name">Amazonite</span>
    if (selectedGemstone) {
      // $(".gemstone-variant").text(
      //   "GEMSTONE - " + selectedGemstone.toUpperCase()
      // );
      $(".gemstone-variant").html(
        "GEMSTONE - " +
          "<span class='selected-swatch-name'>" +
          selectedGemstone.toUpperCase() +
          "</span>"
      );
    }
    $(".swatch-element-data").click(function () {
      const gemstone = $(this).attr("data-value");
      if (gemstone) {
        $(".gemstone-variant").text("GEMSTONE - " + gemstone.toUpperCase());
      } else {
        console.log("No gemstone data-value found");
      }
    });
  });
});
$(document).ready(function () {
  function toTitleCase(str) {
    let exceptions = [
      "and",
      "with",
      "the",
      "for",
      "on",
      "at",
      "by",
      "as",
      "but",
      "so",
      "or",
      "nor",
      "yet",
      "after",
      "before",
      "during",
      "under",
      "over",
      "through",
      "among",
    ];

    return str
      .split(" ")
      .map((word, index) => {
        if (index === 0 || !exceptions.includes(word.toLowerCase())) {
          return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
        }
        return word.toLowerCase();
      })
      .join(" ");
  }

  // Apply title case to the text inside h4 tag
  $(".sub_heading_container h4").text(function (_, text) {
    return toTitleCase(text); // Convert the text to title case
  });
});

function cartButtonUpdate() {
  const checkbox = document.querySelector("#cart_terms_conditions");
  const gemstoneCheckbox = document.querySelector("#cart_gemstone_terms");
  const termsWarning = document.querySelector(".cart-term-warning");
  const checkoutButton = document.querySelector(".checkout-btn");
  
  if (!checkoutButton) return;

  let isValid = true;

  if (checkbox) {
    isValid = isValid && checkbox.checked;
    if (termsWarning) {
      termsWarning.style.display = checkbox.checked ? 'none' : 'block';
    }
  }

  if (gemstoneCheckbox) {
    isValid = isValid && gemstoneCheckbox.checked;
  }

  if (isValid) {
    checkoutButton.disabled = false;
    checkoutButton.classList.remove('disabled');
    checkoutButton.removeAttribute('disabled');
  } else {
    checkoutButton.disabled = true;
    checkoutButton.classList.add('disabled');
    checkoutButton.setAttribute('disabled', 'disabled');
  }
}

document.addEventListener('DOMContentLoaded', cartButtonUpdate);
document.addEventListener('change', function(e) {
  if (e.target && (e.target.id === 'cart_terms_conditions' || e.target.id === 'cart_gemstone_terms')) {
    cartButtonUpdate();
  }
});

// Black Friday Sale Text Functionality (from BF theme)
var saletexthtml = $('.sale-text-price').html();
$(document).on("click", ".swatch-element", function () {   
  $('.sale-text-price').hide();
    setTimeout(function () {
         $('.sale-text-price').html(saletexthtml);
      $('.sale-text-price').show()
      
    },10)
   
})

$('.card__information').each(function () {
  var saletexthtml1 = $(this).find('.sale-text-price').html(); 
    $(this).data('saletext', saletexthtml1);
$(this).find('.swatch-element').on('click', function () {
    var storedSaleText = $(this).closest('.card__information').data('saletext');
    setTimeout(function () {
    
     $(this).closest('.card__information').find('.sale-text-price').html(storedSaleText); 
    }.bind(this), 100); 
  });
});
